import { QuestionnaireResponsesType } from "@/common/types";
import { Separator } from "@/components/ui/separator";

const QuestionnaireResponse = ({
  data,
}: {
  data: QuestionnaireResponsesType;
}) => {
  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 px-4 py-3">
        <div className="col-span-1">
          <p className="font-bold pr-8">{data.question}</p>
        </div>
        {data.answer ? (
          <div className="col-span-1 md:col-span-2">
            <p className="text-gray-500 break-all">{data.answer}</p>
          </div>
        ) : (
          <div className="col-span-1 md:col-span-2">
            {data.answers?.map((answer, index) => (
              <div key={index} className="flex gap-2 items-center">
                <div className="w-2 h-2 bg-gray-500 rounded md:rounded-full"></div>
                <p key={index} className="text-gray-500 break-all">
                  {answer}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
      <Separator />
    </>
  );
};

export default QuestionnaireResponse;
